import styled, { css, DefaultTheme } from 'styled-components';
import { BackgroundColor, Props } from './types';

export default styled.div<Props>`
  background: ${({ theme, color = 'neutral' }) => colorMapping(color, theme)};
  width: 100%;

  ${({ theme, spacing }) =>
    spacing &&
    css`
      padding: ${theme.spacing[`km${spacing}`]};
    `};

  ${({ theme, verticalSpacing }) =>
    verticalSpacing &&
    css`
      padding-top: ${theme.spacing[`km${verticalSpacing}`]};
      padding-bottom: ${theme.spacing[`km${verticalSpacing}`]};
    `};

  ${({ theme, horizontalSpacing }) =>
    horizontalSpacing &&
    css`
      padding-left: ${theme.spacing[`km${horizontalSpacing}`]};
      padding-right: ${theme.spacing[`km${horizontalSpacing}`]};
    `};

  border-radius: ${({ theme }) => theme.border.radius.large};

  ${({ outlined = false, theme }) =>
    outlined &&
    css`
    border: ${theme.border.width.thinner} solid #dadee6; */
  `}

  ${({ elevation, theme }) =>
    elevation &&
    css`
      box-shadow: ${theme.elevation[`ton${elevation}`]};
    `}
`;

function colorMapping(color: BackgroundColor, theme: DefaultTheme) {
  const propsMap = {
    brand: theme.color.background.brand.default,
    'brand-strong': theme.color.background.brand.strong,
    neutral: theme.color.background.neutral.default,
    'neutral-inverted': theme.color.background.neutral.inverted,
    'neutral-weak': theme.color.background.neutral.weak,
    'neutral-strong': theme.color.background.neutral.strong,
    danger: theme.color.background.danger.default,
    'danger-weak': theme.color.background.danger.weak,
    'danger-medium': theme.color.background.danger.medium,
    'danger-strong': theme.color.background.danger.strong,
    success: theme.color.background.success.default,
    'success-weak': theme.color.background.success.weak,
    'success-strong': theme.color.background.success.strong,
    'support-purple': theme.color.support.purple.strong,
    'support-blue': theme.color.support.blue.strong,
    'support-orange': theme.color.support.orange.weak,
    'support-green': theme.color.support.green.weak,
  };

  return propsMap[color];
}
